import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLanguage } from '../hooks/useLanguage'

const TOURS = [
  { key: 'home', path: null, icon: '🏠', label: 'tour_menu_home' },
  { key: 'ingresos', path: '/ingresos', icon: '💰', label: 'tour_menu_ingresos' },
  { key: 'gastos', path: '/gastos', icon: '💸', label: 'tour_menu_gastos' },
  { key: 'ahorro', path: '/ahorro', icon: '🐷', label: 'tour_menu_ahorro' }
]

const BTN_SIZE = 46
const BTN_RIGHT = 16
const BTN_BOTTOM_DESKTOP = 42
const BTN_BOTTOM_MOBILE = 120

export default function TutorialMenu() {
  const { t } = useLanguage()
  const navigate = useNavigate()
  const location = useLocation()
  const [open, setOpen] = useState(false)
  const [narrow, setNarrow] = useState(window.innerWidth < 700)

  useEffect(() => {
    const onResize = () => setNarrow(window.innerWidth < 700)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  function iniciar(path) {
    const destino = path ?? location.pathname
    console.log('[tour] menú: navegando a', destino)
    setOpen(false)
    navigate(destino, { state: { tour: true } })
  }

  return createPortal(
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        title={t('tour_ayuda')}
        style={{
          position: 'fixed',
          right: BTN_RIGHT,
          bottom: `calc(env(safe-area-inset-bottom, 0px) + ${narrow ? BTN_BOTTOM_MOBILE : BTN_BOTTOM_DESKTOP}px)`,
          width: BTN_SIZE,
          height: BTN_SIZE,
          borderRadius: '50%',
          background: 'rgba(128,128,128,0.18)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          border: '1px solid var(--color-border)',
          color: 'var(--color-text)',
          fontWeight: 700,
          fontSize: 18,
          cursor: 'pointer',
          zIndex: 90,
          boxShadow: '0 6px 20px rgba(0,0,0,0.25)'
        }}
      >
        ?
      </button>

      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.6)',
            zIndex: 1000,
            display: 'flex', justifyContent: 'center', alignItems: 'center',
            padding: 16, boxSizing: 'border-box'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: 20,
              width: '100%', maxWidth: 400,
              maxHeight: '80vh', overflowY: 'auto',
              padding: 18, boxSizing: 'border-box',
              display: 'flex', flexDirection: 'column', gap: 10,
              boxShadow: '0 20px 60px rgba(0,0,0,0.5)'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
              <div>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 700 }}>
                  ❓ {t('tour_ayuda')}
                </div>
                <div style={{ fontSize: 12, color: 'var(--color-muted)', marginTop: 3 }}>
                  {t('tour_ayuda_desc')}
                </div>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                style={{
                  background: 'var(--color-bg)', border: '1px solid var(--color-border)',
                  borderRadius: 8, padding: '5px 9px', cursor: 'pointer',
                  color: 'var(--color-text)', flexShrink: 0
                }}
              >
                ✕
              </button>
            </div>

            {TOURS.map((tour) => (
              <button
                key={tour.key}
                type="button"
                onClick={() => iniciar(tour.path)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 12,
                  padding: '14px 16px', borderRadius: 14, cursor: 'pointer',
                  border: '1px solid var(--color-border)',
                  background: 'var(--color-bg)', color: 'var(--color-text)',
                  fontWeight: 600, fontSize: 14, textAlign: 'left'
                }}
              >
                <span style={{ fontSize: 22 }}>{tour.icon}</span>
                <span style={{ flex: 1 }}>{t(tour.label)}</span>
                <span style={{ color: 'var(--color-muted)' }}>›</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </>,
    document.body
  )
}